export const REQUEST_SEARCH = 'request_cateogry3_search' as const
export const SUCCESS_SEARCH = 'success_cateogry3_search' as const
export const FAILURE_SEARCH = 'failure_cateogry3_search' as const

export default {
  REQUEST_SEARCH,
  SUCCESS_SEARCH,
  FAILURE_SEARCH
}
